import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { Command } from './command';
import { CommandEvents } from './command-events';

export class ValiderPartieBasseCommand implements Command<ObjetMaquette> {
    constructor(
        private id: string,
        private events: CommandEvents,
        private objetMaquetteService: ObjetMaquetteService,
        private contexteId: string
    ) {}

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService.validerPartieBasse(this.id, this.contexteId).pipe(
            tap(om => this.events.objetMaquetteModifie$.next(om)),
            tap(om => this.events.structureModifiee$.next(om.id))
        );
    }

    destroy(): void {}
}
